module.exports = __webpack_public_path__ + "assets/img/portfolio-solar.efbaddd3.webp";